import { EnvConfig } from '@gripp/shared-logic';

/**
 * Get the base AppsFlyer OneLink URL for the current environment
 */
export const getOneLinkBaseUrl = (): string => {
  return EnvConfig.prefix === 'prod'
    ? 'https://gripp.onelink.me/JIWC/fodtl90i'
    : 'https://gripp-beta.onelink.me/sv4m/q37k80m3';
};

/**
 * Build an AppsFlyer OneLink URL with deep link parameters
 * @param params - Key-value pairs to include in deep_link_value
 */
export const buildOneLinkUrl = (params: Record<string, string>): string => {
  const base = getOneLinkBaseUrl();
  const deepLinkValue = Object.entries(params)
    .map(([key, value]) => `${key}=${value}`)
    .join('&');

  return `${base}?af_dp=gripp://&deep_link_value=${encodeURIComponent(
    deepLinkValue
  )}`;
};
